import { useEffect, useLayoutEffect } from 'react'

/**
 * useLayoutEffect on the client, useEffect on the server.
 *
 * React warns when useLayoutEffect runs during server rendering (it can't run
 * an effect into static markup). Our animation hooks only do work in the
 * browser anyway, so on the server we fall back to useEffect (which React does
 * not warn about and also no-ops during renderToString). This keeps SSR/publish
 * logs clean without changing client behavior.
 */
export const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect
